export function normalizeAgoraJoinUid(uid) {
  const text = String(uid ?? '').trim()
  if (!text) return null

  if (/^\d+$/.test(text)) {
    const numericUid = Number(text)
    if (Number.isSafeInteger(numericUid) && numericUid > 0) {
      return numericUid
    }
  }

  return text
}

export async function requestAgoraRtcToken({ tokenServer, channel, role, uid } = {}) {
  const tokenServerUrl = String(tokenServer || '').trim()
  const channelName = String(channel || '').trim()
  const roleName = String(role || '').trim() || 'audience'
  const identity = uid == null || String(uid).trim() === '' ? 0 : uid

  if (!tokenServerUrl) {
    throw new Error('token server is required')
  }

  if (!channelName) {
    throw new Error('channel is required')
  }

  const search = new URLSearchParams({
    channel: channelName,
    role: roleName,
    uid: String(identity),
  })

  const resp = await fetch(`${tokenServerUrl}?${search.toString()}`, {
    credentials: 'omit',
  })

  let data = null
  try {
    let { data:_data} = await resp.json()
    data = _data
  } catch (error) {
    throw new Error(`rtc token response is not valid JSON (${resp.status})`)
  }

  if (!resp.ok) {
    throw new Error(data?.error || `rtc token request failed (${resp.status})`)
  }

  if (!data?.token) {
    throw new Error('rtc token missing token')
  }

  if (data?.uid == null || String(data.uid).trim() === '') {
    throw new Error('rtc token missing uid')
  }

  return {
    appId: data.appId || '',
    token: data.token,
    uid: data.uid,
    uidMode: data.uidMode || '',
    expireAt: data.expireAt || null,
    channel: data.channel || channelName,
  }
}
